import { useState } from 'react';
import type { CostItem } from './CreditCostNotice';
import { ConfirmCreditsModal } from './ConfirmCreditsModal';

interface ConfirmRequest {
  items: CostItem[];
  onConfirm: () => void;
  title?: string;
  note?: string;
  confirmLabel?: string;
  recurringHours?: number;
}

/**
 * Hook reutilizável para exigir confirmação de crédito antes de uma ação.
 * Uso:
 *   const { request, modal } = useCreditConfirm();
 *   <button onClick={() => request({ items:[{featureKey:'carrossel', qty:1}], onConfirm: doIt })}>...</button>
 *   {modal}
 */
export function useCreditConfirm() {
  const [req, setReq] = useState<ConfirmRequest | null>(null);

  const request = (cfg: ConfirmRequest) => setReq(cfg);

  const modal = (
    <ConfirmCreditsModal
      open={!!req}
      title={req?.title}
      items={req?.items || []}
      note={req?.note}
      confirmLabel={req?.confirmLabel}
      recurringHours={req?.recurringHours}
      onConfirm={() => { const cb = req?.onConfirm; setReq(null); cb?.(); }}
      onCancel={() => setReq(null)}
    />
  );

  return { request, modal };
}
